// extracted by mini-css-extract-plugin
export default {"active":"industriesDropdown_active__TJY3E","activeBackground":"industriesDropdown_activeBackground__nxZQP"};